$(() => {
  $('.hero-slide').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    pauseOnFocus: false,
    draggable: false,
  });
});
